export enum SpecialPointType {
    MotorOperation,
    LoadOperation,
    LoadSwitching,
    LoadOperationForSpecificVoltage,
    LoadPower,
    CustomPoint,
    RatedPoint,
    MotorAndLoadOperation
}
